//Done by @script imports
// import { database, firestore } from "firebase-admin";
import firebase from "firebase/app";

//Done by @script types Firebase Firestore
export type FirestoreDatabase = firebase.firestore.Firestore;
export type FirestoreTimestamp = firebase.firestore.Timestamp;// | firebase.firestore.FieldValue;
export const FirestoreTimestampConst = firebase.firestore.Timestamp;
export const FirestoreTimestampServerValue = firebase.firestore.FieldValue.serverTimestamp() as any;//marked as any to fit into a FirestoreTimestamp
export const FirestoreTimestampClientValue = () => firebase.firestore.Timestamp.now();
export type FirestoreGeoPoint = firebase.firestore.GeoPoint;

export type FirestoreCollectionReference = firebase.firestore.CollectionReference
export type FirestoreDocumentReference = firebase.firestore.DocumentReference;
export type FirestoreDocumentData = firebase.firestore.DocumentData;
export type FirestoreDocumentSnapshot = firebase.firestore.DocumentSnapshot;
export type FirestoreQuery = firebase.firestore.Query<firebase.firestore.DocumentData>
export type FirestoreQuerySnapshot = firebase.firestore.QuerySnapshot;

//Done by @script types Firebase Realtime Database
export type RealtimeDatabase = firebase.database.Database;
export type RealtimeReference = firebase.database.Reference;
export type DatabaseTimestamp = Object | number;
export const DatabaseTimestampServerValue = firebase.database.ServerValue.TIMESTAMP;